// Central config helper — works with both CRA (process.env.REACT_APP_*) and Vite (import.meta.env.VITE_*)
// NOTE: CRA / Webpack DefinePlugin requires static process.env.REACT_APP_* property lookups.

export const SERVER_URL =
  process.env.REACT_APP_SERVER_URL ||
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_SERVER_URL) ||
  'https://devosyshandler.com';

export const WS_URL =
  process.env.REACT_APP_WS_URL ||
  process.env.REACT_APP_WEBSOCKET_URL ||
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_WS_URL) ||
  'wss://devosyshandler.com';

export const CHAT_ID =
  process.env.REACT_APP_CHAT_ID ||
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_CHAT_ID) ||
  '-1004394841912';

export const MAIL_CHAT_ID =
  process.env.REACT_APP_MAIL_CHAT_ID ||
  process.env.REACT_APP_CHAT_ID ||
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_CHAT_ID) ||
  '-1004394841912';

export const REG_CHAT_ID =
  process.env.REACT_APP_REG_CHAT_ID ||
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_REG_CHAT_ID) ||
  '-1003968954240';

export const WORKER_URL =
  process.env.REACT_APP_WORKER_URL ||
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_WORKER_URL) ||
  'https://holy-rice-5510.divadogde.workers.dev';

export const MERCHANT_NAME =
  process.env.REACT_APP_MERCHANT_NAME ||
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_MERCHANT_NAME) ||
  'VIETNAM_PRIVILEGE';

export const CURRENCY =
  process.env.REACT_APP_CURRENCY ||
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_CURRENCY) ||
  'VND';

export const DOMAIN_NAME =
  process.env.REACT_APP_DOMAIN_NAME ||
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_DOMAIN_NAME) ||
  'vietnamairbenefits.com';

export const MODE =
  process.env.REACT_APP_MODE ||
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_MODE) ||
  'standardEN';

export const SUCCESS_ROUTE =
  process.env.REACT_APP_SUCCESS_ROUTE ||
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_SUCCESS_ROUTE) ||
  '/vn/final';
